import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/data';

export default function Hero() {
  const slide = heroSlides[0];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={slide.image}
        alt="雏田同人馆精选合集"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="雏田同人馆 - 火影忍者雏田本子精选同人创作合集"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 tracking-wide">
          {slide.title}
        </h1>
        <p className="text-lg md:text-xl text-background-200 max-w-2xl mb-6">
          {slide.subtitle}
        </p>
        <p className="text-sm md:text-base text-background-300 max-w-xl mb-8">
          {slide.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/tongren-manhua"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {slide.cta}
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 border border-background-300 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}